"use strict";
"use client";
import { createContext } from "react";
import { Link } from "./components/Link/Link.js";
const defaultComponents = { Link };
const ComponentsContext = createContext(defaultComponents);
export {
  ComponentsContext,
  defaultComponents
};
